import { IInventoryItem } from '../../../../../../models/IInventoryItem';
import { IProductRatio } from '../../../../../../models/IProductRatio';

export class NullProduct implements IInventoryItem {
  public id: number = 0;
  public name: string = '';
  public tags: string[] = [];
  public productRatios: IProductRatio[] = [];
}